'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');
var Theme_index = require('../../Theme/index.js');
require('styled-components');
require('../../Theme/Normalize/index.js');
require('../../colors-b14f6805.js');
require('../../index-33f41a46.js');
require('../../Theme/common/index.js');
require('../../Theme/inputs/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ConfirmationIcon = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "28", height: "28", viewBox: "0 0 28 28", fill: "currentColor" }, props),
    React__default['default'].createElement("path", { d: "M14 28.0317C21.732 28.0317 28 21.7637 28 14.0317C28 6.29975 21.732 0.0317383 14 0.0317383C6.26801 0.0317383 0 6.29975 0 14.0317C0 21.7637 6.26801 28.0317 14 28.0317Z", fill: Theme_index.theme.colors.iconSuccess }),
    React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.1665 13.7762L12.2913 17.901L19.8332 10.3605L19.4205 9.94841L12.2913 17.0759L8.58123 13.3649L8.1665 13.7762Z", fill: Theme_index.theme.colors.white }))); };

exports.default = ConfirmationIcon;
//# sourceMappingURL=index.js.map
